import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { Building2, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0B5D3B] text-white">
      <div className="sib-container py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-md bg-[#0e6a45] flex items-center justify-center">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#D4A840" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 18h18" />
                <path d="M5 18v-3" />
                <path d="M19 18v-3" />
                <path d="M5 15c2.5-4 4.5-6 7-6s4.5 2 7 6" />
                <path d="M8 13v5" />
                <path d="M12 11v7" />
                <path d="M16 13v5" />
              </svg>
            </div>
            <div className="leading-tight">
              <div className="font-bold text-[15px]">{t.common.brand}</div>
              <div className="text-[#D4A840] text-[11px] font-medium">{t.common.brandSub}</div>
            </div>
          </div>
          <p className="text-[13.5px] leading-relaxed text-white/75">{t.footer.about}</p>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase mb-4">{t.footer.quickLinks}</h4>
          <ul className="space-y-2.5 text-[14px] text-white/80">
            <li><Link to="/about" className="hover:text-[#D4A840]">{t.nav.about}</Link></li>
            <li><Link to="/services" className="hover:text-[#D4A840]">{t.nav.services}</Link></li>
            <li><Link to="/opportunities" className="hover:text-[#D4A840]">{t.nav.opportunities}</Link></li>
            <li><Link to="/tender-support" className="hover:text-[#D4A840]">{t.nav.tenderSupport}</Link></li>
            <li><Link to="/jobs" className="hover:text-[#D4A840]">{t.nav.jobs}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase mb-4">{t.footer.legal}</h4>
          <ul className="space-y-2.5 text-[14px] text-white/80">
            <li><Link to="/privacy-policy" className="hover:text-[#D4A840]">{t.footer.privacy}</Link></li>
            <li><Link to="/terms" className="hover:text-[#D4A840]">{t.footer.terms}</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#D4A840]">{t.footer.disclaimer}</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-[#D4A840]">{t.footer.cookie}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase mb-4">{t.footer.contact}</h4>
          <ul className="space-y-3 text-[14px] text-white/85">
            <li className="flex gap-2 items-start"><MapPin size={16} className="mt-0.5 text-[#D4A840]" />{t.contact.hqValue}</li>
            <li className="flex gap-2 items-center"><Mail size={16} className="text-[#D4A840]" /><a href={`mailto:${t.footer.email}`} className="hover:text-[#D4A840]">{t.footer.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="sib-container py-5 text-[13px] text-white/60 flex flex-col md:flex-row justify-between gap-2">
          <div>© {year} {t.common.brand}. {t.footer.rights}</div>
          <div className="text-white/50">{t.inspiration.disclaimer}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
